import { createFileRoute, Navigate } from '@tanstack/react-router';

import { creativesRouteSearchSchema } from '../features/campaigns/creatives/creativesRouteSearch';

export const Route = createFileRoute('/campaigns/creatives')({
  validateSearch: creativesRouteSearchSchema,
  component: CreativesRedirect,
});

function CreativesRedirect() {
  const search = Route.useSearch();
  return <Navigate to="/campaigns/creatives/display" search={search} replace />;
}
